<div #view style="outline: 2px solid black; border: 2px solid #E1E3E3;" class="rect offset-small mat-elevation-z2" (mousedown)="tdoMdiItemMouseDown($event)" (mouseup)="tdoMdiItemMouseUp($event)"
     ngxDrag
     ngxDragPositionStrategy="relative"
     ngxResize
     [ngxResizeWheelDisabled]="true"
     (ngxResized)="onNgxResized($event)"
     (ngxDragged)="onNgxDragged($event)"
     [ngxResizeMinWidth]="200"
     [ngxResizeMinHeight]="200"
     [ngxResizeAspectRatio]="aspectRatio"
     [ngxDragBoundary]="'#tdo-mdi-manager'"
     [ngxResizeBoundary]="'#tdo-mdi-manager'"
     data-cy="mdi-item-container">
  <div (dblclick)="onHeaderDoubleClick($event)" style="cursor: move; width: calc(100% - 60px); height: 38px; position: absolute; pointer-events: visible;" ngxDragHandle data-cy="mdi-item-header"></div>
  <ng-content style="pointer-events: none;"></ng-content>
  <div style="opacity: 0;" [ngxResizeHandle]="handleType.TopLeft" data-resize-handle='TopLeft' data-cy="mdi-item-resize-top-left"></div>
<!--  <div style="opacity: 0;" [ngxResizeHandle]="handleType.Top" data-resize-handle='Top'></div>-->
  <div style="opacity: 0;" [ngxResizeHandle]="handleType.TopRight" data-resize-handle='TopRight' data-cy="mdi-item-resize-top-right"></div>
<!--  <div style="opacity: 0;" [ngxResizeHandle]="handleType.Right" data-resize-handle='Right'></div>-->
  <div style="opacity: 0;" [ngxResizeHandle]="handleType.BottomRight" data-resize-handle='BottomRight' data-cy="mdi-item-resize-bottom-right"></div>
<!--  <div style="opacity: 0;" [ngxResizeHandle]="handleType.Bottom" data-resize-handle='Bottom'></div>-->
  <div style="opacity: 0;" [ngxResizeHandle]="handleType.BottomLeft" data-resize-handle='BottomLeft' data-cy="mdi-item-resize-bottom-left"></div>
<!--  <div style="opacity: 0;" [ngxResizeHandle]="handleType.Left" data-resize-handle='Left'></div>-->
</div>
